module.exports = __webpack_public_path__ + "media/assets/images/shopping/delivery-c6fa78127844a06314f05e16bc72db38.svg";